module.exports = __webpack_public_path__ + "img/35_33.8450e3ff.png";